// src/pages/Private/Student/AssignmentView/SubmitAssignment.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../../../utils/axios';
import './SubmitAssignment.css';

function SubmitAssignment() {
  const { assignmentId } = useParams();
  const navigate = useNavigate();
  const [assignment, setAssignment] = useState(null);
  const [files, setFiles] = useState([]);
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    loadAssignment();
  }, [assignmentId]);

  const loadAssignment = async () => {
    try {
      const response = await axios.get(`/assignments/${assignmentId}`);
      setAssignment(response.data);
    } catch (error) {
      console.error('Ödev yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    formData.append('notes', notes);

    try {
      await axios.post(`/assignments/${assignmentId}/submit`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      navigate(-1);
    } catch (error) {
      console.error('Ödev gönderilemedi:', error);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="submit-assignment">
      <h1>{assignment?.title}</h1>
      
      <div className="assignment-info">
        <h3>Ödev Açıklaması</h3>
        <p>{assignment?.description}</p>
        
        <div className="info-meta">
          <div className="meta-item">
            <span className="meta-label">Teslim Tarihi:</span>
            <span className="meta-value">
              {new Date(assignment?.dueDate).toLocaleDateString('tr-TR')}
            </span>
          </div>
          <div className="meta-item">
            <span className="meta-label">Toplam Puan:</span>
            <span className="meta-value">{assignment?.totalPoints}</span>
          </div>
        </div>

        {assignment?.attachments?.length > 0 && (
          <div className="assignment-attachments">
            <h4>Ek Kaynaklar</h4>
            <ul>
              {assignment.attachments.map((att, index) => (
                <li key={index}>
                  <a href={att.url} target="_blank" rel="noopener noreferrer">
                    {att.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <form onSubmit={handleSubmit} className="submission-form">
        <div className="form-group">
          <label>Dosya Yükle</label>
          <input
            type="file"
            multiple
            onChange={handleFileChange}
            accept=".pdf,.doc,.docx,.zip,.rar"
            required
          />
          <small>PDF, DOC, ZIP veya RAR formatında yükleyin</small>
        </div>

        {files.length > 0 && (
          <div className="selected-files">
            <h4>Seçilen Dosyalar:</h4>
            <ul>
              {files.map((file, index) => (
                <li key={index}>{file.name}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="form-group">
          <label>Notlar</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows="4"
            placeholder="Ödeviniz hakkında eklemek istediğiniz notlar..."
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? 'Gönderiliyor...' : 'Ödevi Gönder'}
          </button>
          <button type="button" className="btn-cancel" onClick={() => navigate(-1)}>
            İptal
          </button>
        </div>
      </form>
    </div>
  );
}

export default SubmitAssignment;